import { Box } from '@palmetto/palmetto-components';

import { SafeHarborEquipmentStatus, SafeHarborEquipmentStatusLabels } from 'types';

import EventBy, { ActivityEvent } from './EventBy';

export interface SafeHarborBadgeUpdatedProps extends ActivityEvent {
  data?: {
    safeHarborEquipmentStatus?: string | null;
  };
}

const SafeHarborBadgeUpdated = ({ event }: { event: SafeHarborBadgeUpdatedProps }) => {
  const safeHarborStatus = event?.data?.safeHarborEquipmentStatus;
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} />{' '}
        {safeHarborStatus != null ? (
          <>
            updated Safe Harbor status to{' '}
            <strong>{SafeHarborEquipmentStatusLabels[safeHarborStatus as SafeHarborEquipmentStatus]}</strong>
          </>
        ) : (
          'removed Safe Harbor Status'
        )}
      </Box>
    </Box>
  );
};

export default SafeHarborBadgeUpdated;
